<template>
    <div class="container" :style="{ backgroundImage: 'url(' + bgImage + ')' }">
          <!-- <div class="title" style="color: rgb(51,51,51);font-size:20PX">
            石狮市安全标准化运行监测平台
          </div> -->
      <div class="tell">
        <div>为了获得最佳用户体验，建议使用 Google Chrome 浏览器(<span @click="uploadGoogle" class="upload" style="cursor: pointer;">点击去下载</span>)。360 浏览器、QQ 浏览器等建议调整到极速模式使用
        </div>
      </div>
      <div class="main">
          <div class="login">
              <!-- <h2 style="font-size:18PX">监管平台登录</h2> -->
              <div class="header">
                <div @click="changePort" class="tab1">企业端登录</div>
                <div class="tab2">监管端登录</div>
              </div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <div class="box">
                  <el-form-item prop="userName">
                    <input size="small" v-model="ruleForm.userName" placeholder="用户名" class="loginInput" @keyup.enter="submitForm('ruleForm')"/>
                    <i class="el-icon-user-solid"></i>
                  </el-form-item>
                </div>
                <div class="box">
                  <el-form-item prop="password">
                    <span class="show-pwd" @click="showPwd">
                      <img v-if="passwordType=='password'" style='width: 20px;height: 20px;' src="@/assets/img/login/eye.png"/>
                      <img v-else style='width: 20px;height: 20px;' src="@/assets/img/login/eye-open.png"/>
                    </span>
                    <input ref="password" size="small" :type="passwordType" placeholder="密码" v-model="ruleForm.password" class="loginInput" @keyup.enter="submitForm('ruleForm')"/>
                    <i class="el-icon-unlock"></i>
                  </el-form-item>
                </div>
                <div style="display:flex;justify-content: space-between;" class="box">
                  <el-form-item style="width: 68%" prop="ca_code">
                    <input style="padding: 3PX 10PX;" size="small" type="ca_code" placeholder="验证码" v-model="ruleForm.ca_code" class="loginInput" @keyup.enter="submitForm('ruleForm')"/>
                    <!-- <i class="el-icon-unlock"></i> -->
                  </el-form-item>
                  <img style="width: 30%;height: 33PX" @click="getId" :src="`/apps/common/captcha?ca_key=${this.ruleForm.ca_key}`" alt="">
                </div>
                <div class="login-error" v-show="loginError!=null">{{ loginError }}</div>
                <div class="login-btn">
                  <el-button size="small" style="border-color:#5190FB;background-color:#5190FB;width:310PX" type="primary" @click="submitForm('ruleForm')" class="loginBtn">登录
                    <!-- <el-button size="mini" style="color: rgb(102,102,102)" type="text" @click.stop="operationManual" class="operationManual">下载操作手册</el-button> -->
                  </el-button>
                </div>
              </el-form>
          </div>
      </div>
    </div>
</template>

<script>
import {api} from '../../api/api'
import md5 from 'blueimp-md5'
import * as types from '@/vuex/types'
import getUid from '@/Util/getUid.js'
export default {
  data () {
    return {
      url: null,
      passwordType: 'password',
      ruleForm: {
        userName: '',
        password: '',
        ca_key: '',
        ca_code: ''
      },
      rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        ca_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loginError: null
    }
  },
  computed: {
    bgImage() {
      this.$store.dispatch('getHostname')
      if (this.$store.getters.hostCL) {
        return require("@/assets/img/login/bg9.jpg"); // 长乐背景图
      } else if (this.hostname == 'risk-supervise-admin.zyrcsoft.com') {
        return require("@/assets/img/login/bg8.jpg"); // 福州背景图
      } else {
        return require("@/assets/img/login/bg8.jpg"); // 默认背景图
      }
    }
  },
  mounted () {
    this.$store.dispatch(types.GETSYSSETTINGS)
    this.getId()
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    getId () {
      this.ruleForm.ca_key = getUid()
    },
    submitForm (formName) {
      this.$store.commit('setUserInfo', null)
      this.loginError = null
      const self = this
      this.$store.commit(types.SESSION_ID, null)
      self.$refs[formName].validate((valid) => {
        if (!valid) return
        this.$http.post(
          '/apps/admin/loginByPassword', { 'username': this.ruleForm.userName, 'password': md5(this.ruleForm.password), 'ca_key': this.ruleForm.ca_key, 'ca_code': this.ruleForm.ca_code }
        ).then((response) => {
          if (response.data.code === 0) {
            let permission = ['/home', '/enterpriseManagement', '/standardization', '/riskManagement', '/hiddenCheck', '/riskWork', '/educationalTraining', '/analysis', '/dataV', '/setting', '/insurance']
            let per = null
            if (response.data.data.auth_list) {
              for (let item of permission) {
                if (response.data.data.auth_list.indexOf(item) > -1) {
                  per = item
                  break
                }
              }
            }
            if (!per) {
              this.$message({
                type: 'error',
                message: '请联系管理员分配权限'
              })
              return
            }
            let sessionId = response.data.data.token
            this.$store.commit(types.SESSION_ID, sessionId)
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            this.getAllDictionary(response.data.data, per)
            this.$store.commit(types.COMPANY_ID, null)
            this.$store.dispatch('getBaseDepartmentTypeList')
          } else {
            // this.loginError = response.data.msg
            this.$message.error(response.data.msg)
            this.getId()
          }
        })
      })
    },
    register () {
      this.$refs['registerForm'].showForm()
    },
    async getAllDictionary (userInfo, per) {
      let res = await this.$http.post(api.dictionary)
      if (res.data.code === 0) {
        let data = res.data.data
        let baseIndustryCode = data.baseIndustryCode
        if(this.$store.getters.hostCL){
          data.baseArea[0].children = data.baseArea[0].children.filter(item => item.id == 350112)
        }
        localStorage.setItem('baseIndustryCode', JSON.stringify(baseIndustryCode))
        localStorage.setItem('baseArea', JSON.stringify(data.baseArea))
        let url = per
        this.$router.push(url)
      }
    },
    operationManual () {
      window.open('https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_control_fuzhou/doc/%E5%AE%89%E5%85%A8%E9%A3%8E%E9%99%A9%E7%AE%A1%E6%8E%A7%E5%B9%B3%E5%8F%B0%28%E4%BC%81%E4%B8%9A%E7%AB%AF%29%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8Cv1.0.pdf')
    },
    uploadGoogle () {
      // window.location.href = 'https://dl.google.com/tag/s/appguid%3D%7B8A69D345-D564-463C-AFF1-A69D9E530F96%7D%26iid%3D%7B6DDC8673-CB76-1680-219A-434B968C6B54%7D%26lang%3Dzh-CN%26browser%3D4%26usagestats%3D1%26appname%3DGoogle%2520Chrome%26needsadmin%3Dprefers%26ap%3Dx64-stable-statsdef_1%26installdataindex%3Dempty/update2/installers/ChromeSetup.exe'
      window.open('https://www.google.cn/chrome/')
    },
    changePort () {
      window.location.href = this.$store.getters.sysUrl.COMPANY_PLATFORM_URL
    }
  }
}
</script>

<style scoped>
.operationManual {
  position: absolute;
  left: 0;
  bottom: -30PX;
}
.register {
  position: absolute;
  right: 0;
  bottom: -30PX;
}
.container {
        display: flex;
        flex-direction: column;
        /* height: 100vh; */
        text-align: center;
        /* background: url(../../assets/img/login/bg8.jpg) center no-repeat; */
        background-size: 100% 100%;
        height: 100vh;
        position: relative;
    }
    header {
      padding: 0 60PX;
        height: 80PX;
        line-height: 80PX;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .main {
        /* background: url(../../assets/img/login/bg2.jpg) no-repeat;
        background-size: 100%;
        height: 100%; */
        height: 100vh;
        /* position: relative; */
    }
    .login {
        width: 390PX;
        height: 306PX;
        background-color: rgba(255, 255, 255, .5);
        /* float: right; */
        /* margin: 100PX 100PX 0 0; */
        position: absolute;
        top: 30vh;
        left: 50%;
        transform: translate(-50%,0);
    }
    h2 {
        padding:20PX 0;
        color: rgb(102, 102, 102);
        font-weight: normal;
    }
    .box {
        width: 80%;
        margin: 0 auto;
    }
    .el-form-item .loginInput{
        -webkit-appearance: none;
        -moz-appearance: none;
        /* appearance: none; */
        background-color: #fff;
        background-image: none;
        border-radius: 4PX;
        border: 1PX solid #bfcbd9;
        box-sizing: border-box;
        color: #000 !important;
        display: block;
        font-size: inherit;
        /* height: 50PX; */
        line-height: 1.8;
        outline: 0;
        padding: 3PX 40PX;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
        position: relative;
    }
    i {
      position: absolute;
      left: 8PX;
      bottom: 8PX;
      font-size: 18PX;
      color: #666
    }
    .login-btn {
      position: relative;
        /* margin-top: 50PX; */
        /* transition: all,5s; */
    }
    .tell {
      width: 100%;
      position: absolute;
      bottom: 2%;
      left: 50%;
      color: #333;
      font-size: 14PX;
      /* cursor: pointer; */
      transform: translate(-50%, 0);
    }
    .loginBtn {
      position: relative;
    }
    .login-error {
    color: #fa5555;
    font-size: 12PX;
    line-height: 1;
    /* margin-top: -10PX; */
    padding-bottom: 5PX;
}
.title {
  position: absolute;
  top: 34%;
  left: 50%;
  transform: translate(-50%,0);
  letter-spacing: 3PX;
}
.login .header {
    width: 100%;
    display: flex;
    margin-bottom: 30PX;
    color: rgb(119, 115, 122);
  }
  .tab1 {
    cursor: pointer;
    /* color: #409EFF; */
    flex: 1;
    padding: 10PX 0;
    box-sizing: border-box;
    border-bottom: 1PX solid rgb(216, 216, 216);
    /* border-bottom: 2PX solid #409EFF; */
    border-right: 1PX solid rgb(216, 216, 216);
  }
  .tab2 {
    color: #409EFF;
    border-bottom: 2PX solid #409EFF;
    cursor: pointer;
    box-sizing: border-box;
    flex: 1;
    padding: 10PX 0;
  }
  .show-pwd {
    cursor: pointer;
    user-select: none;
    position: absolute;
    right: 5px;
    top: 3px;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/components/frame/Login.vue